export default function Privacy() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14 animate-fade-in" data-testid="privacy-page">
      <div className="text-xs uppercase tracking-widest text-accent mb-2">Legal</div>
      <h1 className="font-display font-extrabold text-4xl md:text-5xl">Privacy Policy</h1>
      <p className="text-sm text-muted-foreground mt-2">Last updated: {new Date().toLocaleDateString()}</p>

      <div className="max-w-none mt-8 space-y-6 text-base leading-relaxed">
        <section>
          <h2 className="font-display font-bold text-2xl mt-8 mb-3">What we collect</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li><strong>Google profile info:</strong> your email, name, and profile picture when you sign in.</li>
            <li><strong>Content you post:</strong> threads, replies, listings, photos, and messages.</li>
            <li><strong>Session data:</strong> a session token stored as an httpOnly cookie so you stay signed in for 7 days.</li>
            <li><strong>Payment info:</strong> handled entirely by Stripe. We never see your card number.</li>
            <li><strong>Usage logs:</strong> standard server logs (IP, timestamp, endpoint) for security and debugging.</li>
          </ul>
        </section>

        <section>
          <h2 className="font-display font-bold text-2xl mt-8 mb-3">How we use it</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>Run the forum and marketplace — showing your posts and listings to other users.</li>
            <li>Deliver messages between users.</li>
            <li>Process payments via Stripe.</li>
            <li>Enforce the Community Rules and Terms of Service.</li>
          </ul>
        </section>

        <section>
          <h2 className="font-display font-bold text-2xl mt-8 mb-3">What we share</h2>
          <p>
            We share the minimum needed with our processors: Google (auth), Stripe (payments), and our cloud
            hosting provider (server and storage). We don't sell your personal data.
          </p>
        </section>

        <section>
          <h2 className="font-display font-bold text-2xl mt-8 mb-3">Cookies</h2>
          <p>
            We use a single essential cookie called <code>session_token</code> to keep you signed in. No advertising
            or tracking cookies.
          </p>
        </section>

        <section>
          <h2 className="font-display font-bold text-2xl mt-8 mb-3">Your controls</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>You can edit your bio and location from your profile page.</li>
            <li>You can sign out to clear your session cookie.</li>
            <li>To delete your account and all your content, message the admin from any conversation.</li>
          </ul>
        </section>

        <section>
          <h2 className="font-display font-bold text-2xl mt-8 mb-3">Retention</h2>
          <p>
            Content you post persists until you delete it or your account. Payment records are retained per Stripe's
            requirements. Session tokens expire after 7 days.
          </p>
        </section>

        <section>
          <h2 className="font-display font-bold text-2xl mt-8 mb-3">Children</h2>
          <p>The platform isn't intended for anyone under 18.</p>
        </section>

        <section>
          <h2 className="font-display font-bold text-2xl mt-8 mb-3">Contact</h2>
          <p>Privacy questions? Reach out through in-app messaging to the admin account.</p>
        </section>
      </div>
    </div>
  );
}
